<mf-page title="Nueva sucursal">
  @if (bankBranchDto) {
  <mf-bank-branch
    [bankBranchDto]="bankBranchDto"
    (close)="close()"
    (save)="save($event)" />
  }
</mf-page>
